export default __webpack_public_path__ + "static/media/cashews-icon.4da3586f.svg";